import axios, { AxiosResponse } from 'axios';
import { getBaseDomain, replaceUrlPattern } from '@/requestManager';

import { PointCreator } from '@/classes/PointCreator';
import { PointMoveEvent } from '@/classes/widgets/PointMoveEvent';

import { snakeCaseKeys } from '@/utilities/helpers';

const CREATE_POINT_URL = '/api/v2/points';
const MOVE_POINT_URL   = '/api/v2/points/{id}/move';

interface IMovePointRequestParams {
  id: number,
  params: PointMoveEvent,
}

export const createPointRequest = (params: PointCreator): Promise<AxiosResponse> =>
  axios.post(getBaseDomain() + CREATE_POINT_URL, snakeCaseKeys(params));

export const movePointRequest = ({ id, params }:IMovePointRequestParams): Promise<AxiosResponse> =>
  axios.post(
    getBaseDomain() + replaceUrlPattern(MOVE_POINT_URL, { id }),
    snakeCaseKeys(params));
